export default __webpack_public_path__ + "static/media/donationsPage_banner.3d4a6903.jpg";